<div class="modal-body">
  <div class="row">
    <div class="col-12 text-center">
      <h6 class="h5">{{ 'components.email_send.header' | translate }}</h6>
    </div>
    <div class="col-12">
      <form [formGroup]="form" (submit)="submit()">
        <div class="row g-3">
          <div class="col-12 ">
            <div class="card">
              <div class="card-body">

                <div class="col-12 py-1">
                  <app-multi-select-with-service
                    [formControl]="emailTemplateControl"
                    [searchOnField]="'title'"
                    [sort]="'type'"
                    [selectionMode]="'single_model'"
                    name="email_template"
                    [service]="emailService"
                    [preselectByAttribute]="'is_primary'"
                    [filters]="{type: type}"
                    label="{{ 'components.email_send.form.email_template.label' | translate }}"
                    [reloadEmitter]="reloadTemplatesEmitter"
                    [errorMessages]="{required: ('components.email_send.form.email_template.validation_messages.required' | translate)}"
                  ></app-multi-select-with-service>
                </div>

                <div class="col-12 py-1">
                  <label class="form-label">
                    {{ 'components.email_send.form.recipient.label' | translate }}
                  </label>
                  <div class="input-group">
                    <input class="form-control" disabled readonly [value]="recipient.email">
                  </div>
                </div>

                <div class="col-12 py-1">
                  <div formArrayName="cc_recipients">
                    <p
                      class="small text-muted mb-1">{{ 'components.email_send.form.cc_recipients.label' | translate }}</p>
                    <ng-container
                      *ngFor="let ccRecipient of $any(form.controls.cc_recipients).controls; let index = index"
                    >
                      <div class="row py-1">
                        <div class="col-12">
                          <div class="d-flex flex-row justify-content-start align-items-start">

                            <app-form-group
                              class="flex-fill pe-3"
                              type="text"
                              name="cc_recipients_{{ index }}"
                              label=""
                              [formControl]="$any(ccRecipient)"
                            ></app-form-group>

                            <button
                              (click)="removeRecipient('cc', index)"
                              type="button"
                              class="btn btn-outline-danger"
                            ><i class="fa-solid fa-trash"></i></button>

                          </div>
                        </div>
                      </div>
                    </ng-container>
                    <button (click)="addRecipient('cc')" type="button" class="btn btn-primary w-100">
                      {{ 'components.email_send.form.cc_recipients.add_recipient_btn' | translate }}
                    </button>
                  </div>
                </div>

                <div class="col-12 py-1">
                  <div formArrayName="bcc_recipients">
                    <p
                      class="small text-muted mb-1">{{ 'components.email_send.form.bcc_recipients.label' | translate }}</p>
                    <ng-container
                      *ngFor="let bccRecipient of $any(form.controls.bcc_recipients).controls; let index = index"
                    >
                      <div class="row py-1">
                        <div class="col-12">
                          <div class="d-flex flex-row justify-content-start align-items-start">

                            <app-form-group
                              class="flex-fill pe-3"
                              type="text"
                              name="bcc_recipients_{{ index }}"
                              label=""
                              [formControl]="$any(bccRecipient)"
                            ></app-form-group>

                            <button
                              (click)="removeRecipient('bcc',index)"
                              type="button"
                              class="btn btn-outline-danger"
                            ><i class="fa-solid fa-trash"></i></button>

                          </div>
                        </div>
                      </div>
                    </ng-container>
                    <button (click)="addRecipient('bcc')" type="button" class="btn btn-primary w-100">
                      {{ 'components.email_send.form.bcc_recipients.add_recipient_btn' | translate }}
                    </button>
                  </div>
                </div>

                <div class="col-12 py-1">
                  <app-form-group
                    name="subject"
                    [label]="'components.email_send.form.subject.label' | translate"
                    [formControl]="form.controls.subject"
                  ></app-form-group>
                </div>

                <div class="col-12 py-1">
                  <app-markdown-editor
                    name="pre_content"
                    [label]="'components.email_send.form.pre_content.label' | translate"
                    [formControl]="form.controls.pre_content"
                  ></app-markdown-editor>
                </div>

                <div class="col-12 py-1">
                  <app-markdown-editor
                    name="post_content"
                    [label]="'components.email_send.form.post_content.label' | translate"
                    [formControl]="form.controls.post_content"
                  ></app-markdown-editor>
                </div>

              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="col-6 pt-3">
      <button
        class="btn btn-primary mb-2"
        (click)="showPreview()"
        [disabled]="email === undefined"
      >{{ 'components.email_send.preview_btn' | translate }}</button>
    </div>

    <div class="col-6 text-end pt-3">
      <div class="d-inline-flex flex-column">
        <button
          class="btn btn-primary mb-2"
          (click)="submit()"
          [disabled]="email === undefined || pending"
        >{{ 'components.email_send.submit_btn' | translate }}</button>

        <button
          class="btn btn-secondary"
          (click)="closeEvent.emit()"
        >{{ 'components.email_send.cancel_btn' | translate }}</button>
      </div>
    </div>
  </div>
</div>

@if (email) {
  <app-email-preview
    [email]="email"
    [previewData$]="emailPreviewData$"
    [form]="form"
  ></app-email-preview>
}
